import Vue from 'vue';
import Vuex from 'vuex';
import { BlueSearch } from '@/search/lib/blue-search.js';
import store from './src/schedule/store/index';
import App from './src/schedule/ScheduleApp.vue';

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#schedule-app');
  const options = { ...el.dataset };

  Vue.config.productionTip = false;
  Vue.use(Vuex);
  Vue.use(BlueSearch, options);

  new Vue({
    store: new Vuex.Store(store),
    data: () => ({ ...options }),
    render: h => h(App),
  }).$mount(el);
});
